module.exports = __webpack_public_path__ + "assets/media/kazan-slider-1.3eada9f9.jpg";